import { render, staticRenderFns } from "./bottom-bar.vue?vue&type=template&id=64fd0016&"
import script from "./bottom-bar.vue?vue&type=script&lang=js&"
export * from "./bottom-bar.vue?vue&type=script&lang=js&"
import style0 from "./bottom-bar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RzBottomBar: require('/opt/cargo.front/node_modules/@razlet/ui/lib/modules/components/bottom-bar/index.js').default})
